import { useMemo, useState, useCallback } from 'react';
import useSWR from 'swr';
import { useCookies } from 'react-cookie';
import { AUTH_TOKEN } from '@constants';

const MUTATION_REQUESTS = ['POST', 'PUT', 'DELETE'];

export const useRequest = (url, swrOption) => {
  const [cookies] = useCookies([AUTH_TOKEN]);
  const token = cookies[AUTH_TOKEN];

  const config = useMemo(
    () => ({
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token || '',
      },
    }),
    [token],
  );

  const swrMethods = useSWR([url, config], swrOption);

  return swrMethods;
};

export const useMutation = (url, _options) => {
  const options = _options || {};

  const [res, setRes] = useState({ data: null, error: null, isLoading: false });

  const [cookies] = useCookies([AUTH_TOKEN]);
  const token = cookies[AUTH_TOKEN];

  const config = useMemo(
    () => ({
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: 'Bearer ' + token }),
        ...options?.headers,
      },
      ...options,
    }),
    [options, token],
  );

  const mutate = useCallback(
    async payload => {
      setRes(prevState => ({ ...prevState, isLoading: true }));

      const response = await fetch(url, {
        ...config,
        ...(MUTATION_REQUESTS.includes(options?.method) && {
          body: JSON.stringify(payload),
        }),
      })
        .then(res => res.json())
        .catch(error => setRes(prevState => ({ ...prevState, error })));
      return response;
    },
    [url, config, options],
  );

  return [res, mutate];
};
